

import React, { useEffect, useState } from "react";
import "./Banner.css";
import { Link } from "react-router-dom";

import Apply_Now_Btn from "../../common/apply-now-btn/Apply_Now_Btn";
import Download_Btn from "../../common/download-btn/Download_Btn";
import Apply_Modal from "../../apply-modal/Apply_Modal";

import { useDispatch, useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";

import { IDS } from "../../../utils/IDS";
import { AllAppSetup } from "../../../features/admin/common/Slice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { ShimmerPostItem } from "react-shimmer-effects";

function Banner({ all_banner_text }) {
  const [show, setShow] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const dispatch = useDispatch();
  const appsetup = useSelector((state) => state.common.all_app_setup);

  const brochure = appsetup?.brochure;

  useEffect(() => {
    dispatch(AllAppSetup());
  }, [dispatch]);

  const handleDownload = () => {
    if (!brochure) {
      alert("Brochure PDF is not available");
      return;
    }

    const fullPDFUrl = `${IDS.IMG_URL}${brochure}`;
    window.open(fullPDFUrl, "_blank");
  };

  const isLoading = !all_banner_text || all_banner_text.length === 0;

  return (
    <>

      <section className="home_banner">

        {isLoading ? (
          // 🔥 SHIMMER UI
          <div style={{ padding: "20px" }}>
            <ShimmerPostItem card title cta />
          </div>
        ) : (
          // ✅ ORIGINAL CONTENT
          <Swiper
            modules={[Autoplay, EffectFade]}
            effect="fade"
            fadeEffect={{ crossFade: true }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop={true}
            speed={1200}
          >
            {all_banner_text?.map((item, index) => (
              <SwiperSlide key={index}>
                <div
                  className="banner_bg"
                  style={{
                    backgroundImage: `url(${IDS.IMG_URL}${item?.banner})`,
                  }}
                >
                  <div className="banner_overlay">
                    <div className="container">
                      <div className="banner_content_holder">
                        <div className="left_div">
                          <h5 className="hired_text">{item?.text}</h5>

                          <h5 className="hired_text hired_text2">
                            {item?.heading}
                          </h5>

                          <p className="banner_text">
                            {item?.description}
                          </p>

                          <div className="banner_btn_holder">
                            <Apply_Now_Btn onClick={() => setShow(true)} />
                            <br />
                            <br />
                            <Download_Btn
                              onClick={handleDownload}
                              disabled={downloading || !brochure}
                            />
                          </div>

                          <div className="ratings_div">
                            <div className="rating_img">
                              <img
                                src="/assets/images/home/banner/group-pic.png"
                                alt="group"
                                className="group_pic"
                              />
                            </div>

                            <div className="ratings_holder">
                              <FontAwesomeIcon
                                icon={faStar}
                                style={{ color: "#FFC107" }}
                              />
                              <span className="rating"> 4.8/5</span> Rating Over
                              2500 Reviews
                            </div>
                          </div>


                          <Link className="playstorlink" target="_blank" to={'https://play.google.com/store/apps/details?id=co.khal.mwkiq&pcampaignid=web_share'}> Download the PST IT Solutions Mobile App
                            <img className="playstore" src={process.env.PUBLIC_URL + '/assets/images/home/footer/play-store.png'} />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}

        <Apply_Modal show={show} handleClose={() => setShow(false)} />
      </section>
    </>
  );
}

export default Banner;
